import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import "../../../styles/Poster.scss";

interface Props {
  image: string;
  title: string;
}

Modal.setAppElement("#root");

const Poster: React.FC<Props> = ({ image, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <>
      <div className="event-banner" onClick={() => setIsOpen(true)}>
        <img src={image} alt={title} />
      </div>

      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        className="poster-modal"
        overlayClassName="poster-overlay"
        contentLabel="Event Poster Modal"
      >
        <button className="close-button" onClick={() => setIsOpen(false)}>×</button>
        <div className="zoom-container">
          <img src={image} alt={title} className="zoomable-poster" />
        </div>
      </Modal>
    </>
  );
};

export default Poster;



// import React from "react";
// import "../../../styles/Poster.scss"

// interface Props {
//   image: string;
//   title: string;
// }

// const Poster: React.FC<Props> = ({ image, title }) => (
//   <div className="event-banner">
//     <img src={image} alt={title} />
//   </div>
// );

// export default Poster;
